(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-section/assets/javascripts/casino-section-scrollable.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-section/assets/javascripts/casino-section-scrollable.js');

'use strict';

const {
  useRef,
  useState,
  useEffect
} = React;
const {
  CasinoSectionHeader
} = svs.components.casino_react.casinoSection;
const {
  CasinoGridScrollable
} = svs.components.casino_react;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  ReactIcon: Icon,
  ReactIconButton: IconButton
} = svs.ui;
const Actions = _ref => {
  let {
    ActionButtons,
    scrollableElement,
    scrollState
  } = _ref;
  const isLargeScreen = useMediaQuery(breakpoints.up(BREAKPOINT_AM));
  return React.createElement(React.Fragment, null, ActionButtons && React.createElement(ActionButtons, null), isLargeScreen && React.createElement("div", {
    className: "casino-section-action__button-wrapper"
  }, React.createElement(IconButton, {
    "aria-label": "G\xE5 v\xE4nster",
    disabled: scrollState.leftDisabled,
    onClick: () => scrollableElement.scrollBy({
      left: -1,
      behavior: 'smooth'
    }),
    title: "G\xE5 v\xE4nster"
  }, React.createElement(Icon, {
    icon: "menu-left",
    size: "300"
  })), React.createElement(IconButton, {
    "aria-label": "G\xE5 h\xF6ger",
    disabled: scrollState.rightDisabled,
    onClick: () => scrollableElement.scrollBy({
      left: 1,
      behavior: 'smooth'
    }),
    title: "G\xE5 h\xF6ger"
  }, React.createElement(Icon, {
    icon: "menu-right",
    size: "300"
  }))));
};
const pixelErrorMargin = 6;
const setScrollStateUtil = (scrollElement, setScrollState) => {
  const maxScroll = scrollElement.scrollWidth - scrollElement.clientWidth;
  const scrollMaxLeft = scrollElement.scrollLeft === 0;
  const scrollPositionIsAtMaxPosition = scrollElement.scrollWidth === scrollElement.clientWidth;
  const scrollMaxRight = scrollElement.scrollLeft + pixelErrorMargin >= maxScroll;
  setScrollState({
    leftDisabled: scrollMaxLeft || scrollPositionIsAtMaxPosition,
    rightDisabled: scrollMaxRight || scrollPositionIsAtMaxPosition
  });
};
const CasinoSectionScrollable = _ref2 => {
  let {
    ActionButtons,
    items,
    title
  } = _ref2;
  const isListEmpty = !(items !== null && items !== void 0 && items.length);
  const scrollableElement = useRef(null);
  const [scrollState, setScrollState] = useState({
    leftDisabled: true,
    rightDisabled: false
  });
  useEffect(() => {
    const scrollableEl = scrollableElement.current;
    if (scrollableEl) {
      setScrollStateUtil(scrollableEl, setScrollState); 

      scrollableEl.addEventListener('scroll', e => {
        setScrollStateUtil(e.currentTarget, setScrollState);
      });
      window.addEventListener('resize', () => {
        setScrollStateUtil(scrollableEl, setScrollState);
      });
    }
    return () => {
      if (scrollableEl) {
        scrollableEl.removeEventListener('scroll', setScrollState);
        window.removeEventListener('resize', setScrollState);
      }
    };
  }, [scrollableElement]);
  if (isListEmpty) {
    return null;
  }
  return React.createElement("section", {
    className: "casino-section"
  }, React.createElement(CasinoSectionHeader, {
    ActionButtons: () => React.createElement(Actions, {
      ActionButtons: ActionButtons,
      scrollableElement: scrollableElement === null || scrollableElement === void 0 ? void 0 : scrollableElement.current,
      scrollState: scrollState
    }),
    title: title
  }), React.createElement("div", {
    className: "casino-section__scrollable"
  }, React.createElement(CasinoGridScrollable, {
    items: items,
    ref: scrollableElement
  })));
};
setGlobal('svs.components.casino_react.casinoSection.CasinoSectionScrollable', CasinoSectionScrollable);

 })(window);